import {css} from 'lit';

export const clamAdminShellStyles = css`
    :host {
        display: flex;
        height: 100vh;
        height: 100dvh;
        overflow: hidden;
        background: var(--clam-surface-soft, #f5f6f8);
        font-family: var(--clam-font, 'Inter', system-ui, sans-serif);
        color: var(--clam-text, #333);
    }

    /* === Sidebar === */
    .sidebar {
        position: fixed;
        top: 0;
        left: 0;
        bottom: 0;
        width: var(--clam-sidebar-width, 260px);
        background: var(--clam-darkgray, #424244);
        display: flex;
        flex-direction: column;
        z-index: 100;
        transform: translateX(-100%);
        transition: transform 0.25s ease;
        box-shadow: var(--clam-shadow-lg, 0 4px 16px rgba(0,0,0,0.12));
    }
    .sidebar.open { transform: translateX(0); }

    .sidebar__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: var(--clam-space-4, 16px) var(--clam-space-5, 20px);
        flex-shrink: 0;
    }
    .sidebar__brand {
        display: flex;
        align-items: center;
        gap: var(--clam-space-2, 8px);
    }
    .sidebar__mark {
        width: 32px;
        height: 32px;
        border-radius: var(--clam-radius-sm, 6px);
        background: var(--clam-primary, #5a9d1e);
        color: var(--clam-on-primary, #fff);
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: var(--clam-text-xs, 11px);
        font-weight: 700;
        flex-shrink: 0;
    }
    .sidebar__brand-text {
        color: var(--clam-white, #fdfdfd);
        font-size: var(--clam-text-sm, 13px);
        font-weight: 600;
        white-space: nowrap;
    }
    .sidebar__close {
        background: none;
        border: none;
        color: var(--clam-white-green, #b6d7a8);
        font-size: 20px;
        cursor: pointer;
        padding: 4px;
        display: flex;
    }

    .sidebar__nav {
        flex: 1;
        overflow-y: auto;
        padding-bottom: var(--clam-space-4, 16px);
        scrollbar-width: thin;
        scrollbar-color: var(--clam-border, #e2e8f0) transparent;
    }
    .sidebar__nav::-webkit-scrollbar { width: 8px; }
    .sidebar__nav::-webkit-scrollbar-track { background: transparent; }
    .sidebar__nav::-webkit-scrollbar-thumb {
        background: var(--clam-border, #e2e8f0);
        border-radius: 999px;
        border: 2px solid transparent;
        background-clip: padding-box;
        transition: background 0.15s;
    }
    .sidebar__nav::-webkit-scrollbar-thumb:hover { background: var(--clam-light-gray, #898a8c); }
    .sidebar__nav::-webkit-scrollbar-corner { background: transparent; }

    .nav-group {
        color: var(--clam-light-gray, #898a8c);
        font-size: var(--clam-text-xs, 11px);
        padding: var(--clam-space-4, 16px) var(--clam-space-5, 20px) var(--clam-space-1, 4px);
        text-transform: uppercase;
        letter-spacing: 1px;
        font-weight: 600;
    }

    .nav-item {
        display: flex;
        align-items: center;
        gap: var(--clam-space-2, 8px);
        padding: var(--clam-space-2, 8px) var(--clam-space-5, 20px);
        color: var(--clam-white-green, #b6d7a8);
        cursor: pointer;
        font-size: var(--clam-text-sm, 13px);
        border-left: 3px solid transparent;
        transition: background 0.15s, color 0.15s;
        user-select: none;
    }
    .nav-item:hover {
        background: rgba(107,187,36,0.15);
        color: var(--clam-white, #fdfdfd);
    }
    .nav-item.active {
        background: rgba(107,187,36,0.2);
        color: var(--clam-white, #fdfdfd);
        border-left-color: var(--clam-light-green, #6bbb24);
    }
    .nav-item__icon {
        width: 18px;
        height: 18px;
        flex-shrink: 0;
        opacity: 0.8;
    }

    .badge {
        display: inline-block;
        padding: 1px 6px;
        border-radius: 8px;
        font-size: 9px;
        font-weight: 600;
        margin-left: auto;
    }
    .badge-web { background: rgba(107,187,36,0.3); color: var(--clam-white-green, #b6d7a8); }
    .badge-priv { background: rgba(234,67,53,0.2); color: var(--clam-danger, #ea4335); }

    .sidebar__footer {
        flex-shrink: 0;
        padding: var(--clam-space-3, 12px) var(--clam-space-5, 20px);
        border-top: 1px solid rgba(255,255,255,0.1);
        display: flex;
        flex-direction: column;
        gap: var(--clam-space-2, 8px);
    }
    .sidebar__user {
        display: flex;
        align-items: center;
        gap: var(--clam-space-2, 8px);
        color: var(--clam-white-green, #b6d7a8);
        font-size: var(--clam-text-xs, 11px);
    }
    .sidebar__user-email {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        flex: 1;
    }
    .sidebar__logout {
        background: none;
        border: 1px solid rgba(255,255,255,0.15);
        color: var(--clam-light-gray, #898a8c);
        padding: var(--clam-space-2, 8px) var(--clam-space-3, 12px);
        border-radius: var(--clam-radius-sm, 6px);
        cursor: pointer;
        font-size: var(--clam-text-xs, 11px);
        font-family: var(--clam-font);
        text-align: center;
        width: 100%;
    }
    .sidebar__logout:hover {
        background: rgba(234,67,53,0.15);
        color: var(--clam-danger, #ea4335);
        border-color: rgba(234,67,53,0.3);
    }

    /* === Overlay (mobile) === */
    .sidebar-overlay {
    position: fixed;
        inset: 0;
        background: rgba(0,0,0,0.5);
        z-index: 90;
        display: none;
    }
    .sidebar-overlay.show { display: block; }

    /* === Main area === */
    .main {
        flex: 1;
        display: flex;
        flex-direction: column;
        min-width: 0;
        min-height: 0;
        overflow: hidden;
    }

    .topbar {
        display: flex;
        align-items: center;
        gap: var(--clam-space-3, 12px);
        padding: var(--clam-space-3, 12px) var(--clam-space-4, 16px);
        background: var(--clam-surface, #fff);
        border-bottom: 1px solid var(--clam-border, #e2e8f0);
        height: var(--clam-topbar-height, 56px);
        box-sizing: border-box;
        position: sticky;
        top: 0;
        z-index: 50;
        flex-shrink: 0;
    }

    .hamburger {
        display: flex;
        flex-direction: column;
        gap: 4px;
        background: none;
        border: none;
        cursor: pointer;
        padding: 8px;
        border-radius: var(--clam-radius-sm, 6px);
    }
    .hamburger span {
        width: 22px;
        height: 2px;
        background: var(--clam-text, #333);
        border-radius: 2px;
    }
    .hamburger:hover { background: var(--clam-surface-soft, #f5f6f8); }

    .topbar__title {
        font-size: var(--clam-text-lg, 18px);
        font-weight: 600;
        color: var(--clam-darkgray, #424244);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .content {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        display: flex;
        flex-direction: column;
    }

    /* === Desktop: persistent sidebar === */
    @media (min-width: 1024px) {
        .sidebar {
            position: static;
            transform: none;
            box-shadow: none;
        }
        .sidebar__close { display: none; }
        .sidebar-overlay { display: none !important; }
        .hamburger { display: none; }
        .topbar { padding: var(--clam-space-3, 12px) var(--clam-space-6, 24px); }
    }
    @keyframes clspin { to { transform: rotate(360deg); } }
`;
